import { render, staticRenderFns } from "./whatnow.vue?vue&type=template&id=3c7fb0a6&scoped=true"
import script from "./whatnow.vue?vue&type=script&lang=js"
export * from "./whatnow.vue?vue&type=script&lang=js"
import style0 from "./whatnow.vue?vue&type=style&index=0&id=3c7fb0a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7fb0a6",
  null
  
)

export default component.exports